// extracted by mini-css-extract-plugin
module.exports = {"main":"Login_main__2BWPV","login_form":"Login_login_form__3RKoh","form__link":"Login_form__link__2YUQY"};